import React,{ useEffect, useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  useTheme,
} from "@mui/material";
import {ChevronLeft,ChevronRightOutlined} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import lightLogo from "assets/lightLogo.png";
import sidebarBackground from "assets/side-bar-2.png";
import checkAdminAuth from "helpers/AdminAuth";
import { userNavItems,superAdminNavItems,adminNavItems } from "data/navPages";

const Sidebar = ({
  user,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const { pathname } = useLocation();
  const active = pathname.substring(1);
  const [navItems, setNavItems] = useState(userNavItems);
  const navigate = useNavigate();
  const theme = useTheme();
  const { role } = checkAdminAuth();

  useEffect(() => {
    if (role === "user") {
      setNavItems(userNavItems);
    } else if (role === "superadmin") {
      setNavItems(superAdminNavItems);
    } else {
      setNavItems(adminNavItems);
    }
  }, [role]);

  // ── Handles both normal navigation and the logout action ─────────────────
  const handleNavClick = (item) => {
    if (item.action === "logout") {
      localStorage.clear();
      navigate("/user/login");
      return;
    }
    if (item.path) {
      navigate(`/${item.path}`);
    }
  };

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.secondary[200],
              "& .MuiTypography-root": { color: "#dcdcdc" },
              backgroundColor: theme.palette.background.main,
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.75) 0%, rgba(31, 30, 30, 0.75) 40%, rgba(20, 19, 19, 0.5) 100%), url("${sidebarBackground}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "800px 1107px",
              boxSixing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box m="1.5rem 2rem 1rem 3rem">
              <FlexBetween color={theme.palette.secondary.main}>
                <Box
                  component="img"
                  alt="profile"
                  src={lightLogo}
                  height="40px"
                  width="200px"
                  sx={{ objectFit: "cover" }}
                />
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
            {navItems.map((item, index) => {
                const { text, icon, path, bold, action } = item;

                // Section header (no icon)
                if (!icon) {
                  return (
                    <Typography
                    key={`${text}-${index}`}
                      sx={{ fontWeight: "bold", marginLeft: "50px", textAlign: "left", marginTop: "10px" }}
                    >
                      {text}
                    </Typography>
                  );
                }

                return (
                  <ListItem key={`${text}-${index}`} disablePadding>
                    <ListItemButton
                      onClick={() => handleNavClick(item)}
                      sx={{
                        backgroundColor:
                          active === path
                            ? theme.palette.secondary[200]
                            : "transparent",
                        color:
                          active === path
                            ? theme.palette.primary[600]
                            : theme.palette.secondary[100],
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: "auto",
                          marginLeft: "2rem",
                          marginRight: "1rem",
                          color:
                            active === path
                              ? theme.palette.primary[600]
                              : theme.palette.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <Typography variant="h5" sx={{ fontWeight: bold ? "bold" : "normal" }}>
                        {text}
                      </Typography>
                      {active === path && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
